module.exports = __webpack_public_path__ + "static/elephant-1-59d0401a67d921f7e7e29fd54b541bb4.png";